import { appMethod as app } from '@utils/app';
import { getCurrentPageQueryParams, convertLineStyleData } from '@utils/tools';
import { showNoDevToast } from '@utils/noDevPageList';

import OfficialPage from '../OfficialPage';
import { customEvent } from '@utils/customEvent';
import { ScrollView } from 'src/jisu-component/scroll-view/ScrollView';
import './CommunityDetail.less'


import { TopNav } from '@common/top-nav/TopNav';

var isSubmiting = false //防止重复点击
var likeTap = false //防止重复点击

var eventSource = [
  { action: 'get-coupon', name: '优惠券详情', local_icon: 'icon-news-coupon' },
  {
    action: 'goods-trade',
    name: '商品详情',
    local_icon: 'icon-news-goodsdetail'
  },
  { action: 'community', name: '社区详情', local_icon: 'icon-news-community' },
  {
    action: 'to-franchisee',
    name: '商家详情',
    local_icon: 'icon-news-business'
  },
  {
    action: 'coupon-receive-list',
    name: '优惠券列表',
    local_icon: 'icon-news-coupon'
  },
  { action: 'recharge', name: '储值', local_icon: 'icon-news-storage' },
  { action: 'transfer', name: '付款', local_icon: 'icon-news-payment' },
  {
    action: 'to-promotion',
    name: '代言人中心',
    local_icon: 'icon-news-extension'
  },
  { action: 'scratch-card', name: '刮刮乐', local_icon: 'icon-news-scratch' },
  { action: 'lucky-wheel', name: '大转盘', local_icon: 'icon-news-turntable' },
  { action: 'golden-eggs', name: '砸金蛋', local_icon: 'icon-news-goldegg' },
  { action: 'call', name: '拨打电话', local_icon: 'icon-tokeout-phone' },
  {
    action: 'turn-to-xcx',
    name: '跳转action小程序',
    local_icon: 'icon-news-jump'
  },
  { action: 'share', name: '分享好友', local_icon: 'icon-share' },
  {
    action: 'page-share',
    name: '分享朋友圈',
    local_icon: 'icon-news-sharecircle'
  },
  {
    action: 'refresh-list',
    name: '刷新列表',
    local_icon: 'icon-news-refreshlist'
  },
  {
    action: 'refresh-page',
    name: '刷新页面',
    local_icon: 'icon-news-refreshpage'
  },
  { action: 'contact', name: '联系客服', local_icon: 'icon-news-custom' },
  {
    action: 'preview-picture',
    name: '预览大图',
    local_icon: 'icon-news-coupon'
  },
  { action: 'to-seckill', name: '秒杀', local_icon: 'icon-news-kill' },
  {
    action: 'video-detail',
    name: '视频详情',
    local_icon: 'icon-news-videodetail'
  },
  { action: 'topic', name: '话题详情', local_icon: 'icon-news-topic' },
  { action: 'news', name: '资讯详情', local_icon: 'icon-news-news' },
  { action: 'vcard', name: '名片详情', local_icon: 'icon-vcard' },
  {
    action: 'vcard-msg-list',
    name: '名片消息列表',
    local_icon: 'icon-vcard-msg-list'
  }
]

function ArticleRecommendItemTmpl(props){
  let item = props.data;
  return (
    <div className="recommend-item" onClick={showNoDevToast}>
      <div className="recommend-article" style={{width: item.style != 1 || item.form_data.url.video ? '70%' : '100%'}}>
        <div className="recommend-content">{item.title}</div>
        {
          item.article_type == 3 ? (
            <div className="recommend-adver-footer">
              <span className="recommend-adver-tag">推荐</span>
              <span className="recommend-publish-time">{item.publish_time}</span>
            </div>
          ) : (
            <div className="recommend-key-words">
              <span className="recommend-comment-text">{item.comment_count}评论</span>
              <span className="recommend-comment-text">{item.publish_time}</span>
            </div>
          )
        }
      </div>
      {
        (item.style != 1 || item.form_data.url.video || item.form_data.video[0]) && (
          <div className="img-wrap">
            <img src={item.imgs || (item['form_data'] && item['form_data']['video'] && item['form_data']['video'][0] && item['form_data']['video'][0]['video_url']) || (item['form_data'] && item['form_data']['video'] && item['form_data']['url']['video']['cover'])} />
            {
              ((item['form_data'] && item['form_data']['url'] && item['form_data']['url']['video'] && item['form_data']['url']['video']['cover']) || (item['form_data'] && item['form_data']['video'] && item['form_data']['video'][0] && item['form_data']['video'][0]['video_url'])) && (
                <div className="icon-wrap">
                  <label className="ico-moon icon-news-video-play"></label>
                </div>
              )
            }
          </div>
        )
      }
    </div>
  )
}

export default class CommunityDetail extends OfficialPage {
  state = {
    topNavBarData: {
      isDefault: 0,
      title: '详情'
    },
    articleId: '',
    articleInfo: {},
    likeLogItems: [],
    commentList: [],
    getCommentData: {
      page: 1,
      loading: false,
      nomore: false
    },
    likeLogData: {
      page: 1,
      loading: false,
      nomore: false
    },
    imgData: {},
    showAddArticleBtn: true,
    themeColor: '#00b6f8',
    address: '',
    showActionSheet: false,
    phoneNumCall: '',
    showReplyBox: false,
    replyBoxFocus: false,
    keyboardHeight: '50%',
    replyPlaceholder: '我来说两句',
    innerAudioContext: {
      currentTime: 0,
      duration: 0,
      canPlay: false,
      play: false
    },
    franchisee: '',
    sectionInfo: {}, // 板块详情
    requireComment: false, // 需要评论
    showHiddenContent: false, // 是否发表过评论
    replyParam: {
      text: '',
      agent_user_token: '',
      address: '',
      latitude: '',
      longitude: '',
      comment_img_url: '',
      comment_id: '',
      parent_comment_id: '',
      sub_app_id: ''
    },
    commentContentMaxHeight: 0,
    commentContentHeight: 40,
    commentTab: 0,
    showGoodsModal: false,
    showModal: false,
    communityPublish: {}
  }

  componentWillMount(options = getCurrentPageQueryParams()) {
    let that = this
    app.getStorage({
      key: 'communityThemeColor-' + options.sectionid,
      success: function(res) {
        that.setData({ themeColor: res.data })
      }
    })
    let articleId = options.detail,
      onlyOwnRecord = options.onlyOwnRecord || ''
    let franchisee = options.franchisee || ''
    this.setData({
      articleId: articleId,
      onlyOwnRecord: onlyOwnRecord,
      franchisee: franchisee,
      ['replyParam.sub_app_id']: franchisee
    })
    if (app.isLogin()) {
      // 判断是否登录
      this.getComment()
    } else {
      app.goLogin({
        success: function() {
          that.getComment()
        }
      })
    }
    this.getArticleInfo()
    this.getLikeLog()
    this.countReadCount(articleId)
    app.globalData.communityDetailRefresh = false
  }

  componentDidShow() {
    if (app.globalData.topicTurnToDetail) {
      app.globalData.topicTurnToDetail = false
    }
    if (app.globalData.communityDetailRefresh) {
      this.setData({
        getCommentData: {
          page: 1,
          loading: false,
          nomore: false
        },
        commentList: []
      })
      app.globalData.communityDetailRefresh = false
      this.getComment()
    }
  }

  getArticleInfo = own => {
    let that = this,
      param = {
        article_id: that.data.articleId,
        page: 1,
        page_size: 100,
        sub_app_id: that.data.franchisee
      }
    if (that.data.onlyOwnRecord == 1) {
      param.only_own_record = 1
    }
    app.sendRequest({
      hideLoading: true,
      url: '/index.php?r=AppSNS/GetArticleByPage',
      data: param,
      method: 'post',
      success: function(res) {
        if (res.status == 0 && Array.isArray(res.data) && res.data[0]) {
          let info = res.data[0]
          let newdata = {}
          info.title = unescape(info.title.replace(/\\u/g, '%u'))
          if (info.content.type == 2) {
            if (info.content.url.article) {
              let artBody = info.content.url.article.body
              if (/[>]\s+/.test(artBody)) {
                // 替换空格
                artBody = artBody.replace(/(\>)(\s+)/g, ($0, $1, $2) => {
                  return $1 + new Array($2.length + 1).join('&nbsp;')
                })
              }
              if (/\'/.test(artBody)) {
                // 过滤掉单引号
                artBody = artBody.replace(/\'/g, '"')
              }
              if (/\<img[^<>]*['"]\s*\>/.test(artBody)) {
                // 筛选过滤掉图片标签有错误的属性
                artBody = artBody.replace(
                  /\<img([^<>]*['"])\s*\>/g,
                  ($0, $1) => {
                    return (
                      '<img' +
                      $1.match(/\s[^'"=\s]+\=['"][^"]+['"]/g).join('') +
                      '/>'
                    )
                  }
                )
              }
              if (/<mpvoice/.test(artBody)) {
                // 替换音频
                artBody = artBody.replace(
                  /\<mpvoice[^<>]*\>\<\/mpvoice\>/g,
                  ($0, $1) => {
                    return $0.replace(
                      /\s(\w+)\=\"([^"]*)\"/g,
                      ($00, $01, $03) => {
                        if (/voice\_encode\_fileid/.test($01)) {
                          return (
                            ' src="https://res.wx.qq.com/voice/getvoice?mediaid=' +
                            $03 +
                            '"'
                          )
                        } else if (/name|author/.test($01)) {
                          return $00
                        } else {
                        }
                        return ''
                      }
                    )
                  }
                )
              }
              info.content_text = artBody
              delete info.content.url.article.body
              if (info.content.url.article.type == 3) {
                that.createAudioPlayer(info.content.url.article)
              }
            }
          } else {
            info.content_text = info.content.text.replace(/\n|\\n/g, '\n')
          }
          info.form_data.recommend = info.form_data.recommend.map(rg => {
            if (rg.recommend_good_type == 3) {
              rg.recommend_goods = rg.recommend_goods.map(ri => {
                if (!ri.name) {
                  ri.name = ri.pageRouterName
                    ? ri.pageRouterName.split('/').pop()
                    : ''
                }
                ri.iconImg = ri.iconImg ? ri.iconImg : ri.icon
                if (
                  !ri.name ||
                  !ri.iconImg ||
                  /click_event.*svg$/.test(ri.iconImg)
                ) {
                  let eventObj = eventSource.find(eb => eb.action == ri.action)
                  if (eventObj) {
                    ri.name || (ri.name = eventObj.name)
                    if (!ri.iconImg || /click_event.*svg$/.test(ri.iconImg)) {
                      ri.local_icon = eventObj.local_icon
                    }
                  }
                }
                return ri
              })
            } else if (rg.recommend_good_type == 0) {
              rg.recommend_goods = rg.recommend_goods.map(ri => {
                if (ri.article_type == 3 && ri.form_data.event.action) {
                  let oldEventParams = ri.form_data.event,
                    newEventParams = {}
                  delete ri.form_data
                  Object.keys(oldEventParams).forEach(k => {
                    if (/\-/.test(k)) {
                      newEventParams[k.replace(/\-/g, '_')] = oldEventParams[k]
                    } else {
                      newEventParams[k] = oldEventParams[k]
                    }
                  })
                  ri.event_params = newEventParams
                } else {
                  ri.event_params = ''
                }
                if (ri.form_data && ri.form_data.recommend) {
                  delete ri.form_data.recommend
                }
                return ri
              })
            } else if (rg.recommend_good_type == 1) {
              info.form_data.show_recommend = rg
            } else {
            }
            return rg
          })
          if (info.hidden_content) {
            info.hidden_content = info.hidden_content.replace(/\n|\\n/g, '\n') // 处理隐藏内容换行
          }
          delete info.comment
          newdata.articleInfo = info
          newdata.address = info.address
          if (info.visible_after_comment == 1) {
            // 话题是否评论后可见
            newdata.requireComment = true
          }
          newdata.showHiddenContent = info.show_hidden_content == 1
          if (info.agent_user_token) {
            // 代理
            newdata['replyParam.agent_user_token'] = info.agent_user_token
          }
          if (app.globalData.userInfo.user_token === info.user_token) {
            newdata.isAuthorSelf = true
          }
          that.setData(newdata)
          // WxParse.wxParse(
          //   'wxParseDescription',
          //   'html',
          //   info.content_text,
          //   that,
          //   10
          // )
          that.getThemeColor(info.section_id)
          if (info.content.type == 2 && info.content.url.video) {
            that.getCurVideoUrl(info.content.url.video.url)
          }
        }
      }
    })
  }
  getLikeLog = () => {
    var that = this
    let {
      articleId,
      franchisee,
      likeLogItems,
      likeLogData: { page, loading, nomore }
    } = this.data
    if (loading || nomore) {
      return
    }
    this.setData({
      'likeLogData.loading': true
    })
    app.sendRequest({
      hideLoading: true,
      url: '/index.php?r=AppSNS/GetLikeLogByPage',
      data: {
        page: page,
        obj_type: 1,
        obj_id: articleId,
        page_size: 10,
        sub_app_id: franchisee
      },
      method: 'post',
      success: function({ data, current_page, is_more }) {
        if (current_page === 1) {
          likeLogItems = data
        } else {
          likeLogItems = likeLogItems.concat(data)
        }
        that.setData({
          likeLogItems: likeLogItems,
          'likeLogData.page': current_page + 1,
          'likeLogData.loading': false,
          'likeLogData.nomore': is_more != 1
        })
      },
      fail: function() {
        that.setData({
          'likeLogData.loading': false,
          'likeLogData.nomore': false
        })
      }
    })
  }
  getComment = () => {
    var that = this,
      sdata = that.data.getCommentData
    if (sdata.loading || sdata.nomore) {
      return
    }
    sdata.loading = true
    app.sendRequest({
      url: '/index.php?r=AppSNS/GetCommentByPage',
      data: {
        page: sdata.page,
        article_id: that.data.articleId,
        page_size: 10,
        article_style: 0,
        sub_app_id: that.data.franchisee,
        child_page: 1,
        child_page_size: 5
      },
      method: 'post',
      success: function(res) {
        if (res.status == 0) {
          let info = res.data,
            oldData = that.data.commentList,
            newData = info
          for (var i = 0; i < newData.length; i++) {
            let item = newData[i],
              likecount = item.like_count
            item.like_count_text =
              likecount <= 0
                ? '赞'
                : likecount > 10000
                ? Math.floor(likecount / 10000) + '万'
                : likecount
            item.likeAnimateShow = true
          }
          newData = oldData.concat(newData)
          that.setData({
            commentList: newData,
            'getCommentData.page': sdata.page + 1
          })
        }
        that.setData({
          'getCommentData.loading': false,
          'getCommentData.nomore': res.is_more == 0 ? true : false
        })
      },
      fail: function(res) {
        that.setData({
          'getCommentData.loading': false
        })
      }
    })
  }
  onReachBottom = e => {
    this.scrollTolower(e)
  }
  onPageScroll = e => {
    this.scrollEvent(e)
  }
  scrollTolower = event => {
    switch (this.data.commentTab) {
      case 0:
        this.getComment()
        break
      case 1:
        this.getLikeLog()
        break
    }
  }
  oldscrolltop = 0
  scrollEvent = event => {
    let scrolltop = event.scrollTop,
      oldscrolltop = this.oldscrolltop
    if (scrolltop - oldscrolltop > 60) {
      this.oldscrolltop = scrolltop
      this.setData({
        showAddArticleBtn: false
      })
    } else if (oldscrolltop - scrolltop > 60) {
      this.oldscrolltop = scrolltop
      this.setData({
        showAddArticleBtn: true
      })
    }
  }
  getThemeColor = section_id => {
    var that = this
    app.sendRequest({
      url: '/index.php?r=AppSNS/GetSectionByPage',
      data: {
        page: 1,
        section_id: section_id,
        sub_app_id: that.data.franchisee
      },
      method: 'post',
      success: function(res) {
        if (res.status == 0) {
          let info = res.data[0]
          that.setData({
            themeColor: info.theme_color,
            sectionInfo: info
          })
        }
      }
    })
  }
  turnReply = event => {
    event.currentTarget.dataset.parentid = event.currentTarget.dataset.id
    this.turnComment(event)
  }
  turnComment = event => {
    let requireArticlePost = this.data.articleInfo.require_article_post
    let requireArticleComment = this.data.articleInfo.require_article_comment
    if (requireArticlePost == 0 || requireArticleComment == 0) {
      app.showModal({
        content: '当前话题圈组不允许评论'
      })
      return
    }
    let {
      sectionId,
      commentId,
      parentCommentId,
      replyto,
      articleId
    } = event.currentTarget.dataset
    this.setData({
      showReplyBox: true,
      replyPlaceholder: '回复：' + replyto,
      ['replyParam.section_id']: sectionId,
      ['replyParam.article_id']: articleId,
      ['replyParam.comment_id']: commentId,
      ['replyParam.parent_comment_id']: parentCommentId
    })
  }
  turnToPublish = event => {
    app.turnToPage(
      '/informationManagement/pages/communityPublish/communityPublish?detail=' +
        this.data.articleInfo.section_id +
        (this.data.franchisee ? '&franchisee=' + this.data.franchisee : '')
    )
  }
  articleLike = event => {
    var that = this,
      liked = event.currentTarget.dataset.liked,
      likeCount = +event.currentTarget.dataset.likeCount
    if (likeTap) {
      return
    }
    likeTap = true
    app.sendRequest({
      hideLoading: true,
      url: '/index.php?r=AppSNS/PerformLike',
      data: {
        obj_type: 1, // obj_type 1-话题 2-评论
        obj_id: that.data.articleId, // obj_id 话题或评论的id
        sub_app_id: that.data.franchisee || app.getChainId()
      },
      method: 'post',
      success: function(res) {
        if (res.status == 0) {
          that.getLikeLog()
          if (liked == 1) {
            that.setData({
              'articleInfo.is_liked': 0,
              'articleInfo.like_count': likeCount - 1
            })
            app.showToast({ title: '点赞取消' })
          } else {
            that.setData({
              'articleInfo.is_liked': 1,
              'articleInfo.like_count': likeCount + 1
            })
            app.showToast({ title: '点赞成功' })
          }
          that.relatePagesRefresh()
          that.setData({
            likeLogData: {
              pageL: 1,
              loading: false,
              nomore: false
            }
          })
          that.getLikeLog()
        }
      },
      complete: function() {
        likeTap = false
      }
    })
  }
  commentLike = event => {
    var that = this,
      liked = event.currentTarget.dataset.liked,
      id = event.currentTarget.dataset.id,
      index = +event.currentTarget.dataset.index,
      likeCount = +event.currentTarget.dataset.likeCount
    if (likeTap) {
      return
    }
    likeTap = true
    app.sendRequest({
      hideLoading: true,
      url: '/index.php?r=AppSNS/PerformLike',
      data: {
        obj_type: 2, // obj_type 1-话题 2-评论
        obj_id: id, // obj_id 话题或评论的id
        sub_app_id: that.data.franchisee || app.getChainId()
      },
      method: 'post',
      success: function(res) {
        if (res.status == 0) {
          if (liked == 1) {
            var newData = {},
              likecount = likeCount - 1
            newData['commentList[' + index + '].is_liked'] = 0
            newData['commentList[' + index + '].like_count'] = likecount
            newData['commentList[' + index + '].like_count_text'] =
              likecount <= 0
                ? '赞'
                : likecount > 10000
                ? Math.floor(likecount / 10000) + '万'
                : likecount
            newData['commentList[' + index + '].likeAnimateShow'] = false
            that.setData(newData)
            app.showToast({ title: '点赞取消' })
          } else {
            var newData = {},
              likecount = likeCount + 1
            newData['commentList[' + index + '].is_liked'] = 1
            newData['commentList[' + index + '].like_count'] = likecount
            newData['commentList[' + index + '].like_count_text'] =
              likecount <= 0
                ? '赞'
                : likecount > 10000
                ? Math.floor(likecount / 10000) + '万'
                : likecount
            newData['commentList[' + index + '].likeAnimateShow'] = false
            that.setData(newData)
            app.showToast({ title: '点赞成功' })
          }
          that.relatePagesRefresh()
          setTimeout(function() {
            let newData = {}
            newData['commentList[' + index + '].likeAnimateShow'] = true
            that.setData(newData)
          }, 480)
        }
      },
      complete: function() {
        likeTap = false
      }
    })
  }
  previewImage = event => {
    let { img, imgsArr } = event.currentTarget.dataset
    if (!Array.isArray(imgsArr)) {
      imgsArr = [img]
    }
    app.previewImage({
      current: img,
      urls: imgsArr
    })
  }
  showActionSheet = event => {
    let that = this,
      telNum = that.data.articleInfo.phone,
      telArr = [telNum.substr(0, 3), telNum.substr(3, 4), telNum.substr(7)],
      isIphone = /ios/i.test(app.globalData.systemInfo.platform)
    if (isIphone) {
      app.makePhoneCall({
        phoneNumber: telNum,
        success: function() {},
        fail: function() {}
      })
    } else {
      that.setData({
        phoneNumCall: telArr.join('-'),
        showActionSheet: true
      })
    }
  }
  rePublish = e => {
    let newdata = {
      'communityPublish.show': true,
      'communityPublish.articleId': this.data.articleId
    }
    if (this.data.articleInfo.content.type == 2) {
      newdata['communityPublish.publishType'] = 2
    }
    this.setData(newdata)
  }
  showGoods = () => {
    this.setData({
      showModal: true
    })
  }
  closeModal = () => {
    this.setData({
      showModal: false
    })
  }
  showModal = () => {
    this.setData({
      showModal: true
    })
  }
  onShareAppMessage = res => {
    let that = this
    let shareTitle = this.data.articleInfo.title
    let sharePath = '/informationManagement/pages/communityDetail/communityDetail';
    sharePath += '?from_share=1'
    return app.shareAppMessage({
      title: shareTitle,
      path: sharePath,
      success: function(res) {
        app.showToast({ title: '转发成功' })
        app.CountSpreadCount(that.data.articleId)
        that.relatePagesRefresh()
      },
      fail: function(res) {}
    })
  }
  turnToReport = () => {
    app.turnToPage(
      '/informationManagement/pages/communityReport/communityReport?detail=' +
        this.data.articleId +
        '&sectionid=' +
        this.data.articleInfo.section_id +
        (this.data.franchisee ? '&franchisee=' + this.data.franchisee : '')
    )
  }
  getLocByLatAndLng = (lat, lng, cb) => {
    app.sendRequest({
      url: '/index.php?r=Map/GetAreaInfoByLatAndLng',
      data: {
        latitude: lat,
        longitude: lng
      },
      method: 'post',
      success: function(data) {
        if (data.status == 0 && typeof cb == 'function') {
          cb(data.data)
        }
      }
    })
  }
  backToPre = () => {
    app.navigateBack()
  }
  closeActionSheet = event => {
    this.setData({ showActionSheet: false })
  }
  makePhoneCall = event => {
    app.makePhoneCall({
      phoneNumber: this.data.articleInfo.phone,
      success: function() {},
      fail: function() {
        app.showModal({ content: '拨打电话失败' })
      }
    })
    this.closeActionSheet()
  }
  cancelReply = () => {
    this.setData({ showReplyBox: false, replyBoxFocus: false })
    this.clearCommentInput()
  }
  replyTimer = null
  submitReply = (event, repeat) => {
    let that = this,
      { replyParam, franchisee } = this.data
    if (this.replyTimer) {
      clearTimeout(this.replyTimer)
      this.replyTimer = null
    }
    replyParam.text = replyParam.text // 去除两端的空格
    if (!replyParam.text) {
      if (repeat === undefined) {
        this.replyTimer = setTimeout(() => this.submitReply(event, true), 500)
        return
      }
      return
    }
    if (isSubmiting) {
      return
    }
    isSubmiting = true
    if (!replyParam.sub_app_id && franchisee) {
      // 子店话题详情回复评论
      replyParam.sub_app_id = franchisee
    }
    app.sendRequest({
      url: '/index.php?r=AppSNS/AddComment',
      data: replyParam,
      method: 'post',
      success: function(res) {
        app.showToast({
          title: '回复成功',
          success: function() {
            let { comment_count } = that.data.articleInfo
            that.setData({
              showReplyBox: false,
              replyBoxFocus: false,
              'articleInfo.comment_count': +comment_count + 1
            })
          }
        })
        that.relatePagesRefresh()
        that.clearCommentInput()
        let { requireComment, showHiddenContent } = that.data
        if (requireComment && !showHiddenContent) {
          that.setData({
            showHiddenContent: true
          })
        }
        that.setData({
          'getCommentData.page': 1,
          'getCommentData.loading': false,
          'getCommentData.nomore': false,
          commentList: []
        })
        that.getComment()
      },
      complete: function(res) {
        isSubmiting = false
      }
    })
  }
  replyInput = event => {
    this.setData({
      'replyParam.text': event.target.value
    })
  }
  openWXMap = () => {
    let articleInfo = this.data.articleInfo
    app.openLocation({
      latitude: +articleInfo.latitude,
      longitude: +articleInfo.longitude,
      address: articleInfo.address
    })
  }
  countReadCount = articleId => {
    app.sendRequest({
      url: '/index.php?r=AppSNS/CountReadCount',
      method: 'get',
      data: {
        article_id: articleId || this.data.communityId,
        sub_app_id: this.data.franchisee
      },
      success: function() {}
    })
  }
  replyFocus = e => {
    if (e.detail.height) {
      let curKbHeight = e.detail.height
      kbHeight = e.detail.height
      if (/iPhone\s?X/i.test(app.globalData.systemInfo.model)) {
        curKbHeight = 365
      }
      this.setData({
        replyBoxFocus: true,
        keyboardHeight: curKbHeight + 'px'
      })
      return
    }
    this.setData({ replyBoxFocus: true })
  }
  replyBlur = e => {
    this.setData({ replyBoxFocus: false })
  }
  createAudioPlayer = article => {
    const innerAudioContext = app.createInnerAudioContext()
    this.innerAudioContext = innerAudioContext
    innerAudioContext.src = article.audio_url
    innerAudioContext.onCanplay(() => {
      this.setData({
        'innerAudioContext.canPlay': true,
        'innerAudioContext.duration': article.duration || 0
      })
    })
    innerAudioContext.onError(res => {
      app.showModal({ content: res.errCode + ':' + res.errMsg })
    })
  }
  audioPlayAct = () => {
    if (!this.data.innerAudioContext.canPlay) {
      return
    }
    this.audioTimer && clearInterval(this.audioTimer)
    if (this.data.innerAudioContext.play) {
      this.setData({
        'innerAudioContext.play': false,
        'innerAudioContext.currentTime': this.innerAudioContext.currentTime
      })
      this.innerAudioContext.pause()
      return
    }
    this.innerAudioContext.play()
    this.audioTimer = setInterval(() => {
      this.setData({
        'innerAudioContext.play': true,
        'innerAudioContext.currentTime': this.innerAudioContext.currentTime
      })
      if (!this.data.innerAudioContext.duration) {
        this.setData({
          'innerAudioContext.duration': this.innerAudioContext.duration
        })
      }
    }, 1000)
  }
  getCurVideoUrl = url => {
    let that = this
    app.sendRequest({
      url: '/index.php?r=AppNews/GetVideoUrl',
      data: { argv: url },
      success: function(res) {
        that.setData({
          'articleInfo.content.url.video.url': res.data
        })
      }
    })
  }
  replyLineChange = e => {
    let that = this
    let lineHeight = 40
    let marginTop = 45
    let commentContentHeight = lineHeight
    let maxHeight = this.data.commentContentMaxHeight
    app.getBoundingClientRect('#comment-box', rect => {
      if (Array.isArray(rect) && rect[0]) {
        commentContentHeight = e.detail.lineCount * lineHeight
        if (rect[0].top > marginTop && e.detail.lineCount >= 1) {
          if (rect[0].top - marginTop <= lineHeight) {
            maxHeight = commentContentHeight + lineHeight
            that.setData({
              commentContentMaxHeight: maxHeight
            })
          }
          that.setData({
            commentContentHeight
          })
        }
        if (rect[0].top <= marginTop && commentContentHeight <= maxHeight) {
          that.setData({
            commentContentHeight
          })
        }
      }
    })
  }
  replyImageChoose = () => {
    let that = this
    app.chooseImage(imageUrls => {
      that.setData({
        ['replyParam.comment_img_url']: imageUrls[0]
      })
    }, 1)
  }
  replyImagePreview = () => {
    let commentImage = this.data.replyParam.comment_img_url
    app.previewImage({
      current: commentImage
    })
  }
  replyImageDelete = () => {
    this.setData({
      ['replyParam.comment_img_url']: ''
    })
  }
  replyLocationChoose = () => {
    let that = this
    app.chooseLocation({
      success({ name, address, latitude, longitude }) {
        let newdata = {}
        newdata['replyParam.latitude'] = latitude
        newdata['replyParam.longitude'] = longitude
        if (name || address) {
          newdata['replyParam.address'] = name || address
        } else {
          that.getLocByLatAndLng(latitude, longitude, function(res) {
            address = res.address || ''
            that.setData({
              ['replyParam.address']: address
            })
          })
        }
        that.setData(newdata)
      }
    })
  }
  replyLocationDelete = () => {
    this.setData({
      ['replyParam.address']: '',
      ['replyParam.latitude']: '',
      ['replyParam.longitude']: ''
    })
  }
  switchCommentTab = e => {
    this.setData({
      commentTab: Number(e.currentTarget.dataset.num)
    })
  }
  goCommentDetail = e => {
    let { id, articleId } = e.currentTarget.dataset
    let { franchisee } = this.data,
      franchiseeParam = franchisee ? `&franchisee=${franchisee}` : ''
    app.turnToPage(
      `/informationManagement/pages/communityComments/communityComments?detail=${id}&articleId=${articleId}${franchiseeParam}`
    )
  }
  turnToCommunityPage = e => {
    let { section_id } = this.data.articleInfo
    if (!section_id) {
      app.showModal({
        content: '板块不存在'
      })
      return
    }
    let franchiseeParam = this.data.franchisee
      ? '&franchisee=' + this.data.franchisee
      : ''
    app.turnToPage(
      `/informationManagement/pages/communityPage/communityPage?detail=${section_id}${franchiseeParam}`
    )
  }
  commentImageLoad = e => {
    let ow = e.currentTarget.width,
      oh = e.currentTarget.height,
      path = e.currentTarget.dataset.path,
      dw = 375,
      dh = 240,
      sw,
      sh
    if (ow / oh > dw / dh) {
      sw = dw
      sh = (dw * oh) / ow
    } else {
      sh = dh
      sw = (dh * ow) / oh
    }
    this.setData({
      [path]: `width:${sw}rpx;height:${sh}rpx;`
    })
  }
  turnToUsercenter = event => {
    let userInfo = app.getUserInfo()
    if (!userInfo || !userInfo.user_token) {
      app.showModal({
        content: '您暂未登陆，请先登陆'
      })
      return
    }
    let { usertoken, sourcetype } = event.currentTarget.dataset
    let franchiseeParam = this.data.franchisee
      ? '&franchisee=' + this.data.franchisee
      : ''
    if (sourcetype === undefined) {
      return
    }
    if (usertoken) {
      franchiseeParam += '&usertoken=' + usertoken + '&sourcetype=' + sourcetype
    }
    app.turnToPage(
      '/informationManagement/pages/communityUsercenter/communityUsercenter?detail=' +
        franchiseeParam
    )
  }
  tapBackPageTop = () => {
    app.pageScrollTo({
      scrollTop: 0
    })
  }
  clearCommentInput = () => {
    this.setData({
      ['replyParam.text']: '',
      ['replyParam.agent_user_token']: '',
      ['replyParam.address']: '',
      ['replyParam.latitude']: '',
      ['replyParam.longitude']: '',
      ['replyParam.comment_img_url']: '',
      ['replyParam.comment_id']: '',
      ['replyParam.parent_comment_id']: ''
    })
  }
  bindEventTapHandler = e => {
    let form = e.currentTarget.dataset.eventParams
    let action = form.action
    let args = [form]
    if (this.data.franchisee) {
      args.push(this.data.franchisee)
    }
    customEvent.clickEventHandler[action] &&
      customEvent.clickEventHandler[action].apply(null, args)
  }
  turnToGoodsDetail = event => {
    let dataset = event.currentTarget.dataset
    let id = dataset.id
    let style = dataset.style
    let appId = dataset.appId
    let franchiseeId = appId === app.getAppId() ? this.data.franchisee : appId
    let franchiseeParam = franchiseeId ? '&franchisee=' + franchiseeId : ''
    if (style == 3) {
      app.turnToPage(
        '/pages/toStoreDetail/toStoreDetail?detail=' + id + franchiseeParam
      )
    } else {
      app.turnToPage(
        '/detailPage/pages/goodsDetail/goodsDetail?detail=' +
          id +
          franchiseeParam
      )
    }
  }
  turnToArticle = event => {
    if (event.currentTarget.dataset.articleType == 3) {
      this.bindEventTapHandler(event)
      return
    }
    let id = event.currentTarget.dataset.id
    let franchiseeParam = this.data.franchisee
      ? '&franchisee=' + this.data.franchisee
      : ''
    app.turnToPage(
      '/informationManagement/pages/newsDetail/newsDetail?detail=' +
        id +
        franchiseeParam
    )
  }
  gotoCouponDetail = event => {
    let id = event.currentTarget.dataset.couponId
    let franchiseeParam = this.data.franchisee
      ? '&franchisee=' + this.data.franchisee
      : ''
    app.turnToPage(
      '/pages/couponDetail/couponDetail?couponStatus=recieve&detail=' +
        id +
        franchiseeParam
    )
  }
  relatePagesRefresh = () => {
    app.globalData.topicRefresh = true
    app.globalData.communityPageRefresh = true
    app.globalData.communityUsercenterRefresh = true
    app.globalData.franchiseeCommunity = true
  }
  goLivePlay = e => {
    let liveId = e.currentTarget.dataset.id
    let paramstr = ''
    if (app.globalData.PromotionUserToken) {
      paramstr =
        '&custom_params=' +
        encodeURIComponent(
          JSON.stringify({
            user_token: app.globalData.PromotionUserToken
          })
        )
    }
    app.turnToPage(
      'plugin-private://wx2b03c6e691cd7370/pages/live-player-plugin?room_id=' +
        liveId +
        paramstr
    )
  }

  privateStopNoop(e) {
    e.stopPropagation()
  }

  render() {
    const {
      showModal,
      sectionInfo,
      articleInfo,
      undefined,
      wxParseDescription,
      showReplyBox,
      showActionSheet,
      innerAudioContext,
      requireComment,
      showHiddenContent,
      address,
      newsItem,
      commentTab,
      commentList,
      isAuthorSelf,
      getCommentData,
      likeLogItems,
      phoneNumCall,
      replyBoxFocus,
      keyboardHeight,
      replyPlaceholder,
      replyParam,
      commentContentHeight
    } = this.state
    return (
      <div>
        <TopNav title="详情" />
        <div
          className={'communityDetail-wrap ' + (showModal ? 'notRoll' : '')}
          id="communityDetail"
        >
          <div className="communityDetail-main">
            <div className="community-flex">
              <div
                className={
                  'communityDetail-cover community-li-cover ' +
                  (sectionInfo.article_style == 0 ? 'circle' : 'square')
                }
                onClick={this.turnToUsercenter}
                data-usertoken={articleInfo.user_token}
                data-sourcetype={articleInfo.source_type}
              >
                <img
                  className="communityDetail-head"
                  src={articleInfo.headimgurl}
                  lazyload="true"
                />
              </div>
              <div className="communityDetail-author community-li-author">
                <div className="communityDetail-name-box">
                  <span
                    className="communityDetail-name community-li-name"
                    selectable="true"
                  >
                    {articleInfo.nickname}
                  </span>
                  {articleInfo.hot_flag == 1 && (
                    <div className="community-hot-wrap">
                      <img src="http://cdn.jisuapp.cn/static/webapp/images/topic.png" />
                    </div>
                  )}
                </div>
                <div className="communityDetail-time community-li-time communityDetail-name-box">
                  <span className="communityDetail-time-time" selectable="true">
                    {articleInfo.add_time}
                  </span>
                  <span>人气</span>
                  {articleInfo.comment_count > 0 && <span className="communityDetail-popularity">
                    {articleInfo.comment_count}
                  </span>}
                </div>
              </div>
            </div>
            {articleInfo.content && articleInfo.content.imgs && (
              <div className="main-content">
                {(articleInfo.content.type == undefined ||
                  articleInfo.content.type == 0 ||
                  articleInfo.content.url.video) && (
                  <div className="communityDetail-title">
                    {articleInfo.title}
                  </div>
                )}
                {(articleInfo.content.type == undefined ||
                  articleInfo.content.type == 0) && (
                  <div className="communityDetail-content">
                    <span className="text-p" selectable="true">
                      {articleInfo.content_text}
                    </span>
                  </div>
                )}
                {(articleInfo.content.type == undefined ||
                  articleInfo.content.type == 0) && (
                  <div className="communityDetail-img">
                    {articleInfo.content.imgs.map((item, index) => {
                      return (
                        <div
                          key={index}
                          className={
                            articleInfo.content.imgs.length == 1
                              ? 'communityDetail-imgli-one'
                              : 'communityDetail-imgli'
                          }
                        >
                          {articleInfo.content.imgs.length == 1 ? (
                            <img
                              src={item}
                              data-img={item}
                              data-imgs-arr={articleInfo.content.imgs}
                              mode="widthFix"
                              onClick={this.previewImage}
                              lazyload="true"
                            />
                          ) : (
                            <img
                              src={item}
                              data-img={item}
                              data-imgs-arr={articleInfo.content.imgs}
                              mode="widthFix"
                              onClick={this.previewImage}
                              lazyload="true"
                            />
                          )}
                        </div>
                      )
                    })}
                  </div>
                )}
                {articleInfo.content.type == 2 &&
                  articleInfo.content.url.article && (
                    <div>
                      <div className="communityDetail-title">
                        {articleInfo.content.url.article.title}
                      </div>
                      <div className="article-from">
                        {articleInfo.content.url.article.author && (
                          <span className="author" selectable="true">
                            {articleInfo.content.url.article.author}
                          </span>
                        )}
                        <span className="nickname" selectable="true">
                          {articleInfo.content.url.article.nickname}
                        </span>
                        <span className="publish-time" selectable="true">
                          {articleInfo.content.url.article.publish_time}
                        </span>
                      </div>
                    </div>
                  )}
                {articleInfo.content.type == 2 &&
                  articleInfo.content.url.article && (
                    <div className="communityDetail-link-content">
                      {false && <video></video>}
                      <TaroParseTmpl
                        data={{ wxParseData: wxParseDescription.nodes }}
                      ></TaroParseTmpl>
                      {articleInfo.content.url.article.type == 4 && (
                        <div className="communityDetail-link-video">
                          <video
                            className="myVideo"
                            src={articleInfo.content.url.article.video_url}
                            controls
                            hidden={showReplyBox || showActionSheet}
                          ></video>
                        </div>
                      )}
                      {articleInfo.content.url.article.type == 3 && (
                        <div
                          className={
                            'communityDetail-link-audio' +
                            (innerAudioContext.play
                              ? ' communityDetail-link-audio-play'
                              : '')
                          }
                        >
                          <div
                            className="audio-logo"
                            onClick={this.audioPlayAct}
                          ></div>
                          <div className="audio-info">
                            <div className="audio-title">
                              {articleInfo.content.url.article.title}
                            </div>
                            <div className="audio-progress-bg">
                              <div
                                className="audio-progress"
                                style={convertLineStyleData(
                                  'width:' +
                                  audioTools.playProgress(
                                    innerAudioContext.currentTime,
                                    innerAudioContext.duration
                                  )
                                )}
                              >
                                <span className="audio-progress-point"></span>
                              </div>
                            </div>
                            <div className="audio-time">
                              <span className="audio-currentTime">
                                {audioTools.timeStampChangeTime(
                                  innerAudioContext.currentTime
                                )}
                              </span>
                              <span className="audio-duration">
                                {audioTools.timeStampChangeTime(
                                  innerAudioContext.duration
                                )}
                              </span>
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                  )}
                {articleInfo.content.type == 2 &&
                  articleInfo.content.url.video && (
                    <div className="communityDetail-topic-video">
                      <video
                        src={articleInfo.content.url.video.url}
                        hidden={showReplyBox || showActionSheet}
                        controls
                      ></video>
                    </div>
                  )}
                {articleInfo.hidden_content && (
                  <React.Fragment>
                    {requireComment && showHiddenContent ? (
                      <div>
                        <span
                          className="hidden-content"
                          space="true"
                          decode="true"
                          selectable="true"
                        >
                          {articleInfo.hidden_content}
                        </span>
                      </div>
                    ) : (
                      <div className="seemore-after-comment">
                        <div className="arrow-group">
                          <span className="ico-moon icon-downarrow arrow-1"></span>
                          <span className="ico-moon icon-downarrow arrow-2"></span>
                        </div>
                        <div
                          className="comment-btn"
                          onClick={this.turnComment}
                          data-section-id={articleInfo.section_id}
                          data-article-id={articleInfo.id}
                          data-replyto="我来说两句"
                          data-comment-id="0"
                          data-parent-comment-id="0"
                        >
                          评论后查看更多
                        </div>
                      </div>
                    )}
                  </React.Fragment>
                )}
              </div>
            )}
            {articleInfo.content && articleInfo.content.type == 2 && (
              <div className="communityDetail-state">
                本页面采用应用内搜索技术自动抓取，在为重新编辑原始内容的情况下对版式做了优化，以提升阅读体验。
              </div>
            )}
            <div className="communityDetail-location-report">
              {address && (
                <div
                  className="communityDetail-location"
                  onClick={this.openWXMap}
                >
                  <label className="ico-moon icon-community-location"></label>
                  {address}
                </div>
              )}
              <div
                className="communityDetail-report-wrap"
                onClick={this.turnToReport}
              >
                <label className="ico-moon icon-community-report"></label>
                <span className="communityDetail-report">举报</span>
              </div>
            </div>
          </div>
          {articleInfo.is_recommend == 1 && (
            <React.Fragment>
              {articleInfo.form_data.recommend.map((recItem, index) => {
                return (
                  <div className="newsDetail-recommend" key={index}>
                    {recItem.recommend_good_type == 3 && (
                      <div className="more-operations">
                        {recItem.recommend_goods.length != 0 && (
                          <div className="title">更多操作</div>
                        )}
                        <div
                          className={
                            'operations' +
                            (recItem.recommend_goods.length < 3
                              ? recItem.recommend_goods.length
                              : '3')
                          }
                          onClick={showNoDevToast}
                        >
                          {recItem.recommend_goods.map((recList, index) => {
                            return (
                              <div key={index}>
                                {recList.action == 'share' ? (
                                  <span
                                    className="sharefriends"
                                    opentype="share"
                                    data-eventParams={recList}
                                  >
                                    <div className="icon-wrap">
                                      {recList.local_icon ? (
                                        <span className="ico-moon icon-share"></span>
                                      ) : (
                                        <img
                                          src={recList.iconImg}
                                          lazyload="true"
                                        />
                                      )}
                                    </div>
                                    <div className="name">分享好友</div>
                                  </span>
                                ) : recList.action == 'contact' ? (
                                  <div className="concat-custom">
                                    <div className="icon-wrap">
                                      {recList.local_icon ? (
                                        <span className="ico-moon icon-news-custom"></span>
                                      ) : (
                                        <img
                                          src={recList.iconImg}
                                          lazyload="true"
                                        />
                                      )}
                                      <span
                                        opentype="contact"
                                        sessionFrom="newsDetail"
                                      ></span>
                                    </div>
                                    <div className="name">联系客服</div>
                                  </div>
                                ) : recList.action == 'turn-to-xcx' ? (
                                  <div>
                                    <Navigator
                                      target="miniProgram"
                                      opentype="navigate"
                                      appId={recList['xcx-appid']}
                                      path={recList['xcx-page-url']}
                                      extraData
                                      version="release"
                                    >
                                      <div className="icon-wrap">
                                        {recList.local_icon ? (
                                          <span
                                            className={
                                              'ico-moon ' + recList.local_icon
                                            }
                                          ></span>
                                        ) : (
                                          <img
                                            src={recList.iconImg}
                                            lazyload="true"
                                          />
                                        )}
                                      </div>
                                      <div className="name">
                                        {recList.name}
                                      </div>
                                    </Navigator>
                                  </div>
                                ) : (
                                  <div
                                    onClick={this.bindEventTapHandler}
                                    data-event-params={recList}
                                  >
                                    <div className="icon-wrap">
                                      {recList.local_icon ? (
                                        <span
                                          className={
                                            'ico-moon ' + recList.local_icon
                                          }
                                        ></span>
                                      ) : (
                                        <img
                                          src={recList.iconImg}
                                          lazyload="true"
                                        />
                                      )}
                                    </div>
                                    <div className="name">{recList.name}</div>
                                  </div>
                                )}
                              </div>
                            )
                          })}
                        </div>
                      </div>
                    )}
                  </div>
                )
              })}
            </React.Fragment>
          )}
          {articleInfo.is_recommend == 1 && (
            <React.Fragment>
              {articleInfo.form_data.recommend.map((recItem, index) => {
                return (
                  <div className="newsDetail-recommend" key={index}>
                    {recItem.recommend_good_type == 0 &&
                    recItem.recommend_goods.length > 0 ? (
                      <div className="recommmend-list">
                        <div className="catalog">推荐文章</div>
                        {(
                          <React.Fragment>
                            {recItem.recommend_goods.map((item, index) => {
                              return (
                                <div key={index}>
                                  {item.article_type == 3 &&
                                  item.event_params.action == 'turn-to-xcx' ? (
                                    <Navigator
                                      target="miniProgram"
                                      opentype="navigate"
                                      appId={item.event_params['xcx-appid']}
                                      path={item.event_params['xcx-page-url']}
                                      extraData
                                      version="release"
                                    >
                                      <ArticleRecommendItemTmpl
                                        data={item}
                                      ></ArticleRecommendItemTmpl>
                                    </Navigator>
                                  ) : item.article_type == 3 &&
                                    item.event_params.action == 'share' ? (
                                    <div>
                                      <span
                                        className="news-share-button"
                                        opentype="share"
                                        data-eventParams={newsItem.event_params}
                                        onClick={this.onShareAppMessage}
                                      >
                                        <ArticleRecommendItemTmpl
                                          data={item}
                                        ></ArticleRecommendItemTmpl>
                                      </span>
                                    </div>
                                  ) : item.article_type == 3 &&
                                    item.event_params.action == 'contact' ? (
                                    <div>
                                      <div className="contact-button">
                                        <span
                                          opentype="contact"
                                          sessionFrom="newsDetail"
                                        ></span>
                                        <ArticleRecommendItemTmpl
                                          data={item}
                                        ></ArticleRecommendItemTmpl>
                                      </div>
                                    </div>
                                  ) : (
                                    <div
                                      data-id={item.id}
                                      onClick={this.turnToArticle}
                                      data-article-type={item.article_type}
                                      data-event-params={item.event_params}
                                    >
                                      <ArticleRecommendItemTmpl
                                        data={item}
                                      ></ArticleRecommendItemTmpl>
                                    </div>
                                  )}
                                </div>
                              )
                            })}
                          </React.Fragment>
                        )}
                      </div>
                    ) : recItem.recommend_good_type == 1 &&
                      recItem.recommend_goods.length > 0 ? (
                      <div className="recommmend-list goods-list">
                        <div className="catalog">推荐商品</div>
                        {recItem.recommend_goods.map((item, index) => {
                          return (
                            <div
                              className="recommend-item"
                              data-id={item.id}
                              data-app-id={item.app_id}
                              onClick={this.turnToGoodsDetail}
                              key={index}
                            >
                              <div>
                                <div className="img-wrap">
                                  <img
                                    src={item.cover}
                                    lazyload="true"
                                  />
                                </div>
                                <div className="recommend-article">
                                  <div className="recommend-content">
                                    {item.title}
                                  </div>
                                  <div className="recommend-goods-price">
                                    <span style={convertLineStyleData('color:#FC4541;')}>
                                      {'¥' + item.price}
                                    </span>
                                  </div>
                                  <div
                                    className="recommend-goods-sales"
                                    style={convertLineStyleData('color:#999;font-size:20rpx;margin-bottom:0;')}
                                  >
                                    {'月销' + item.sales + '件'}
                                  </div>
                                </div>
                              </div>
                            </div>
                          )
                        })}
                      </div>
                    ) : recItem.recommend_good_type == 2 &&
                      recItem.recommend_goods.length > 0 ? (
                      <div
                        className="recommmend-list"
                        style={convertLineStyleData('padding: 20rpx 30rpx;')}
                      >
                        <div className="catalog">优惠券</div>
                        {recItem.recommend_goods.map((coupon, index) => {
                          return (
                            <React.Fragment key={index}>
                              <div
                                className="ticket"
                                onClick={this.gotoCouponDetail}
                                data-coupon-id={coupon.id}
                              >
                                <div
                                  className="top-section"
                                  style={convertLineStyleData('border-color: ' + coupon.list_color)}
                                >
                                  {coupon.type == 0 ? (
                                    <React.Fragment>
                                      <div className="detail-info">
                                        <div className="name">
                                          {coupon.title}
                                        </div>
                                        <div className="use-condition">
                                          {'使用条件：满' +
                                            coupon.condition +
                                            '元，减' +
                                            coupon.value +
                                            '元'}
                                        </div>
                                      </div>
                                      <div
                                        className="background-word-area"
                                        style={convertLineStyleData(
                                          'border-color:' + coupon.list_color
                                        )}
                                      >
                                        <div
                                          className="background-circle"
                                          style={convertLineStyleData(
                                            'background-color:' +
                                            coupon.list_color
                                          )}
                                        ></div>
                                        <div className="background-word">
                                          减
                                        </div>
                                      </div>
                                    </React.Fragment>
                                  ) : coupon.type == 1 ? (
                                    <React.Fragment>
                                      <div className="detail-info">
                                        <div className="name">
                                          {coupon.title}
                                        </div>
                                        <div className="use-condition">
                                          {'使用条件: 打' + coupon.value + '折'}
                                        </div>
                                      </div>
                                      <div
                                        className="background-word-area"
                                        style={convertLineStyleData(
                                          'border-color:' + coupon.list_color
                                        )}
                                      >
                                        <div
                                          className="background-circle"
                                          style={convertLineStyleData(
                                            'background-color:' +
                                            coupon.list_color
                                          )}
                                        ></div>
                                        <div className="background-word">
                                          折
                                        </div>
                                      </div>
                                    </React.Fragment>
                                  ) : coupon.type == 2 ? (
                                    <React.Fragment>
                                      <div className="detail-info">
                                        <div className="name">
                                          {coupon.title}
                                        </div>
                                        <div className="use-condition">
                                          {'使用条件：可抵扣' +
                                            coupon.value +
                                            '元'}
                                        </div>
                                      </div>
                                      <div
                                        className="background-word-area"
                                        style={convertLineStyleData(
                                          'border-color:' + coupon.list_color
                                        )}
                                      >
                                        <div
                                          className="background-circle"
                                          style={convertLineStyleData(
                                            'background-color:' +
                                            coupon.list_color
                                          )}
                                        ></div>
                                        <div className="background-word">
                                          代
                                        </div>
                                      </div>
                                    </React.Fragment>
                                  ) : coupon.type == 3 ? (
                                    <React.Fragment>
                                      <div className="detail-info">
                                        <div className="name">
                                          {coupon.title}
                                        </div>
                                        {coupon.extra_condition == '' ? (
                                          <div className="use-condition">
                                            {'使用条件：直接兑换' +
                                              coupon.coupon_goods_info.title}
                                          </div>
                                        ) : coupon.extra_condition.price ? (
                                          <div className="use-condition">
                                            {'使用条件：消费满' +
                                              coupon.extra_condition.price +
                                              '元可兑换' +
                                              coupon.coupon_goods_info.title}
                                          </div>
                                        ) : (
                                          coupon.extra_condition.goods_id && coupon.condition_goods_info ? (
                                            <div className="use-condition">
                                              {'使用条件：购买' +
                                                coupon.condition_goods_info
                                                  .title +
                                                '可兑换' +
                                                coupon.coupon_goods_info.title}
                                            </div>
                                          ) : ''
                                        )}
                                      </div>
                                      <div
                                        className="background-word-area"
                                        style={convertLineStyleData(
                                          'border-color:' + coupon.list_color
                                        )}
                                      >
                                        <div
                                          className="background-circle"
                                          style={convertLineStyleData(
                                            'background-color:' +
                                            coupon.list_color
                                          )}
                                        ></div>
                                        <div className="background-word">
                                          兑
                                        </div>
                                      </div>
                                    </React.Fragment>
                                  ) : coupon.type == 4 ? (
                                    <React.Fragment>
                                      <div className="detail-info">
                                        <div className="name">
                                          {coupon.title}
                                        </div>
                                        <div className="use-condition">
                                          {'使用条件: 储值金可充值' +
                                            coupon.value +
                                            '元'}
                                        </div>
                                      </div>
                                      <div
                                        className="background-word-area"
                                        style={convertLineStyleData(
                                          'border-color:' + coupon.list_color
                                        )}
                                      >
                                        <div
                                          className="background-circle"
                                          style={convertLineStyleData(
                                            'background-color:' +
                                            coupon.list_color
                                          )}
                                        ></div>
                                        <div className="background-word">
                                          储
                                        </div>
                                      </div>
                                    </React.Fragment>
                                  ) : (
                                    coupon.type == 5 && (
                                      <React.Fragment>
                                        <div className="detail-info">
                                          <div className="name">
                                            {coupon.title}
                                          </div>
                                          <div className="use-condition">
                                            {'使用条件: ' +
                                              coupon.extra_condition}
                                          </div>
                                        </div>
                                        <div
                                          className="background-word-area"
                                          style={convertLineStyleData(
                                            'border-color:' + coupon.list_color
                                          )}
                                        >
                                          <div
                                            className="background-circle"
                                            style={convertLineStyleData(
                                              'background-color:' +
                                              coupon.list_color
                                            )}
                                          ></div>
                                          <div className="background-word">
                                            通
                                          </div>
                                        </div>
                                      </React.Fragment>
                                    )
                                  )}
                                  <div
                                    className="receive-btn"
                                    onClick={this.gotoCouponDetail}
                                    data-coupon-id={coupon.id}
                                    style={convertLineStyleData(
                                      'background-color:' + coupon.list_color
                                    )}
                                  >
                                    领取
                                  </div>
                                </div>
                                <div className="bottom-section">
                                  <div>
                                    {'有效期 ' +
                                      coupon.start_use_date +
                                      '至' +
                                      coupon.end_use_date +
                                      ' ' +
                                      (coupon.exclude_holiday == 0
                                        ? ''
                                        : '除去法定节假日') +
                                      ' ' +
                                      (coupon.exclude_weekend == 0
                                        ? ''
                                        : '周一至周五') +
                                      ' ' +
                                      coupon.start_use_time +
                                      '-' +
                                      coupon.end_use_time}
                                  </div>
                                </div>
                              </div>
                            </React.Fragment>
                          )
                        })}
                      </div>
                    ) : (
                      recItem.recommend_good_type == 7 &&
                      recItem.recommend_goods.length > 0 && (
                        <div className="live-list">
                          <div className="catalog">推荐直播</div>
                          {recItem.recommend_goods.map((live, index) => {
                            return (
                              <React.Fragment key={index}>
                                <div
                                  className="live-wrap"
                                  data-id={live.roomid}
                                  onClick={this.goLivePlay}
                                >
                                  <div className="live-room">
                                    {live.live_status == 101 && (
                                      <div className="live-online">
                                        正在直播
                                      </div>
                                    )}
                                    {live.live_status == 102 && (
                                      <div className="live-notice">
                                        <div className="live-notice-title green-color">
                                          预告
                                        </div>
                                        <div className="live-notice-time">
                                          {live.start_time}
                                        </div>
                                      </div>
                                    )}
                                    {live.live_status == 103 && (
                                      <div className="live-notice">
                                        <div className="live-notice-title blue-color">
                                          回看
                                        </div>
                                        <div className="live-notice-time">
                                          {live.end_time}
                                        </div>
                                      </div>
                                    )}
                                    <img
                                      src={live.cover_img}
                                      mode="aspectFill"
                                    />
                                    <div className="live-anchor">
                                      {live.anchor_img ? (
                                        <React.Fragment>
                                          <img
                                            className="live-anchor-head"
                                            src={live.anchor_img}
                                            mode="aspectFill"
                                          />
                                          <div className="live-anchor-name">
                                            {live.anchor_name}
                                          </div>
                                        </React.Fragment>
                                      ) : (
                                        <React.Fragment>
                                          <div className="live-anchor-name">
                                            {'主播：' + live.anchor_name}
                                          </div>
                                        </React.Fragment>
                                      )}
                                    </div>
                                  </div>
                                  <div className="live-title ellipsis">
                                    {live.name}
                                  </div>
                                  {live.goods && live.goods.length > 0 && (
                                    <div className="live-goods">
                                      <img
                                        className="live-goods-img"
                                        src={live.goods[0].cover_img}
                                        mode="aspectFill"
                                      />
                                      <div className="live-goods-info">
                                        <div className="live-goods-name ellipsis">
                                          {live.goods[0].name}
                                        </div>
                                        <div className="live-goods-price">
                                          {'¥' + live.goods[0].price}
                                        </div>
                                      </div>
                                      <div className="ico-moon icon-community-group-arrow"></div>
                                    </div>
                                  )}
                                </div>
                              </React.Fragment>
                            )
                          })}
                        </div>
                      )
                    )}
                  </div>
                )
              })}
            </React.Fragment>
          )}
          {sectionInfo.name && (
            <div
              className="relative-section-info"
              onClick={this.turnToCommunityPage}
            >
              <div className="section-logo">
                <img
                  src={sectionInfo.img || sectionInfo.background_pic}
                  lazyload="true"
                />
              </div>
              <div className="section-text">
                <div className="section-name">{sectionInfo.name}</div>
                <div className="section-otherinfo">
                  <span className="ico-moon icon-community-follow"></span>
                  <span className="otherinfo-item">
                    {sectionInfo.xcx_comment_count + '人关注'}
                  </span>
                  <span className="ico-moon icon-community-topic"></span>
                  <span className="otherinfo-item">
                    {sectionInfo.xcx_article_count + '个话题'}
                  </span>
                </div>
              </div>
            </div>
          )}
          {/*  显示拒绝原因和重新发布按钮  */}
          {articleInfo.audit_status == 2 && (
            <div className="refuse-detail">
              <div className="refuse-reason">
                <span className="refuse-title">拒绝原因</span>
                <span className="refuse-explain">
                  {!articleInfo.audit_reason ? '无' : articleInfo.audit_reason}
                </span>
              </div>
              <div>
                <span className="re-publish" onClick={this.rePublish}>
                  重新发布
                </span>
              </div>
            </div>
          )}
          <div
            className="communityDetail-art"
            hidden={articleInfo.audit_status == 2}
          >
            {/*  新版评论显示  */}
            <div className="communityDetail-comment-list-box">
              <div className="communityDetail-comment-list-top">
                <div
                  className={
                    'communityDetail-comment-list-top-reply-box ' +
                    (commentTab === 0
                      ? 'communityDetail-comment-list-top-selected'
                      : '')
                  }
                  onClick={this.switchCommentTab}
                  data-num="0"
                >
                  <div>
                    <span>回复</span>
                  </div>
                  <div>
                    <span>{'(' + articleInfo.comment_count + ')'}</span>
                  </div>
                </div>
                <div
                  className={
                    'communityDetail-comment-list-top-like-box ' +
                    (commentTab === 1
                      ? 'communityDetail-comment-list-top-selected'
                      : '')
                  }
                  onClick={this.switchCommentTab}
                  data-num="1"
                >
                  <div>
                    <span>点赞</span>
                  </div>
                  <div>
                    <span>{'(' + articleInfo.like_count + ')'}</span>
                  </div>
                </div>
              </div>
              {/*  评论内容  */}
              <div
                className="communityDetail-comment-list"
                hidden={commentTab !== 0}
              >
                {commentList.map((item, index) => {
                  return (
                    <div
                      className="communityDetail-comment-list-item"
                      key={index}
                    >
                      <div className="communityDetail-comment-list-left">
                        <img
                          className="communityDetail-comment-list-avatar"
                          src={item.headimgurl}
                          onClick={this.turnToUsercenter}
                          data-usertoken={item.user_token}
                          data-sourcetype={item.source_type}
                          lazyload="true"
                        />
                      </div>
                      <div className="communityDetail-comment-list-right">
                        <div className="communityDetail-comment-list-right-top">
                          <span className="communityDetail-comment-list-nickname">
                            {item.nickname}
                          </span>
                          <div className="communityDetail-comment-list-operation">
                            <span
                              className="ico-moon icon-news-comment"
                              onClick={this.turnComment}
                              data-section-id={articleInfo.section_id}
                              data-article-id={articleInfo.id}
                              data-replyto={item.nickname}
                              data-comment-id={item.id}
                              data-parent-comment-id={item.id}
                            ></span>
                            <span
                              className={
                                'ico-moon icon-news-' +
                                (item.is_liked == 1 ? '' : 'un') +
                                'like'
                              }
                              style={convertLineStyleData(
                                item.is_liked == 1 ? 'color: #59607b;' : ''
                              )}
                              onClick={this.commentLike}
                              data-liked={item.is_liked}
                              data-id={item.id}
                              data-index={index}
                              data-like-count={item.like_count}
                            ></span>
                            <span>{item.like_count}</span>
                          </div>
                        </div>
                        <span
                          className="communityDetail-comment-list-content"
                          onClick={this.goCommentDetail}
                          data-type="simple"
                          data-id={item.id}
                          data-article-id={articleInfo.id}
                        >
                          {item.content.text}
                        </span>
                        {item.content.comment_img_url && (
                          <div
                            className="communityDetail-comment-list-image"
                            style={convertLineStyleData(item.content.comment_img_style)}
                            onClick={this.previewImage}
                            data-img={item.content.comment_img_url}
                          >
                            <img
                              src={item.content.comment_img_url}
                              mode="aspectFill"
                              onLoad={this.commentImageLoad}
                              data-path={
                                'commentList[' +
                                index +
                                '].content.comment_img_style'
                              }
                              lazyload="true"
                            />
                            <div>
                              <span>查看原图</span>
                            </div>
                          </div>
                        )}
                        <div className="communityDetail-comment-list-otherInfo">
                          <div className="communityDetail-comment-list-otherInfo-left">
                            {item.content.address && (
                              <React.Fragment>
                                <span className="ico-moon icon-community-location"></span>
                                <span className="communityDetail-comment-list-otherInfo-location">
                                  {item.content.address}
                                </span>
                              </React.Fragment>
                            )}
                            <span>{item.content.add_time}</span>
                          </div>
                        </div>
                        {/*  评论的回复  */}
                        {item.child_comment &&
                          item.child_comment.data &&
                          item.child_comment.data.length ? (
                            <div className="communityDetail-comment-list-reply-box">
                              {item.child_comment.data.map(
                                (childComment, cIdx) => {
                                  return (
                                    <div
                                      className="communityDetail-comment-list-reply"
                                      key={cIdx}
                                    >
                                      <span className="communityDetail-comment-list-reply-nickname">
                                        {childComment.content.nickname}
                                      </span>
                                      <span
                                        className="communityDetail-comment-list-reply-content"
                                        onClick={this.turnComment}
                                        data-section-id={articleInfo.section_id}
                                        data-article-id={articleInfo.id}
                                        data-replyto={
                                          childComment.content.nickname
                                        }
                                        data-comment-id={childComment.id}
                                        data-parent-comment-id={item.id}
                                      >
                                        {': ' + childComment.content.text}
                                      </span>
                                      {childComment.content.comment_img_url && (
                                        <div className="comment-img-text">
                                          <span
                                            className="ico-moon icon-news-comment-image"
                                            onClick={this.previewImage}
                                            data-img={
                                              childComment.content
                                                .comment_img_url
                                            }
                                          ></span>
                                          <span
                                            className
                                            onClick={this.previewImage}
                                            data-img={
                                              childComment.content
                                                .comment_img_url
                                            }
                                          >
                                            查看图片
                                          </span>
                                        </div>
                                      )}
                                    </div>
                                  )
                                }
                              )}
                              <div
                                className="communityDetail-comment-list-reply-more"
                                onClick={this.goCommentDetail}
                                data-type="simple"
                                data-id={item.id}
                                data-article-id={articleInfo.id}
                              >
                                <span>
                                  {'共' + item.child_comment.count + '条评论 >'}
                                </span>
                              </div>
                            </div>
                          ) : ''}
                      </div>
                    </div>
                  )
                })}
                {/*  评论仅作者可见  */}
                {articleInfo.owner_visible == 1 && !isAuthorSelf ? (
                  <div className="commmunityDetail-comment-author-canseen">
                    <div>
                      <span className="ico-moon icon-community-nosee"></span>
                    </div>
                    <div>评论仅作者可见</div>
                  </div>
                ) : getCommentData.nomore && commentList.length <= 0 ? (
                  <div className="communityDetail-comment-list-nocomment">
                    <span className="ico-moon icon-no-criticism"></span>
                    <div>暂无评论</div>
                  </div>
                ) : (
                  <div></div>
                )}
                {/*  没有评论时的提示  */}
              </div>
              {/*  点赞列表  */}
              {likeLogItems.map((item, index) => {
                return (
                  <div
                    className="communityDetail-like-list"
                    hidden={commentTab !== 1}
                    key={index}
                  >
                    {likeLogItems.length > 0 && (
                      <React.Fragment>
                        {likeLogItems.map((item, index) => {
                          return (
                            <div
                              className="communityDetail-like-list-item"
                              key={index}
                              onClick={this.turnToUsercenter}
                              data-usertoken={item.user_token}
                              data-sourcetype={item.source_type}
                            >
                              <img
                                src={item.headimgurl}
                                lazyload="true"
                              />
                              <span>{item.nickname}</span>
                            </div>
                          )
                        })}
                      </React.Fragment>
                    )}
                    {likeLogItems.length == 0 && (
                      <div className="communityDetail-like-list-nolike">
                        <span className="ico-moon icon-community-group-thumb"></span>
                        <div>暂无点赞</div>
                      </div>
                    )}
                  </div>
                )
              })}
            </div>
            {/*  ++++++++2019-4-1-14:34  */}
          </div>
          {!showReplyBox && (
            <div
              className="communityDetail-bottom"
              hidden={articleInfo.audit_status == 2}
            >
              <div className="bottom-icons-group">
                <span
                  className={
                    'communityDetail-likebtn2 ico-moon ' +
                    (articleInfo.is_liked == 1
                      ? 'icon-community-thumb-up'
                      : 'icon-collect')
                  }
                  data-liked={articleInfo.is_liked}
                  data-like-count={articleInfo.like_count}
                  onClick={this.articleLike}
                  style={convertLineStyleData(
                    (articleInfo.is_liked == 1 ? 'color :#59607b;' : '') +
                    ';font-size:19px;'
                  )}
                >
                </span>
                {articleInfo.form_data && articleInfo.form_data.show_recommend && articleInfo.form_data.show_recommend.recommend_goods.length >
                  0 && (
                  <div
                    className="communityDetail-review"
                    data-section-id={articleInfo.section_id}
                    data-article-id={articleInfo.id}
                    data-comment-id="0"
                    data-parent-comment-id="0"
                    onClick={this.turnComment}
                    data-replyto="我来评论"
                  >
                    <span className="ico-moon icon-communityDetail-reply"></span>
                  </div>
                )}
                <span
                  className="communityDetail-likebtn2"
                  onClick={showNoDevToast}>
                  <span className="ico-moon icon-communityDetail-share"></span>
                </span>
                {articleInfo.phone && (
                  <div
                    className="communityDetail-phone"
                    onClick={this.showActionSheet}
                  >
                    <span className="ico-moon icon-telephone"></span>
                  </div>
                )}
              </div>
              {articleInfo.form_data && articleInfo.form_data.show_recommend && articleInfo.form_data.show_recommend.recommend_goods.length >
                0 ? 
                <div
                  className="communityDetail-goods"
                  onClick={this.showGoods}
                >
                  {articleInfo.form_data && articleInfo.form_data.show_recommend && ('文中商品(' +
                    articleInfo.form_data.show_recommend.recommend_goods
                      .length +
                    ')')}
                </div> : <span
                  className="communityDetail-btn"
                  onClick={this.turnComment}
                  data-section-id={articleInfo.section_id}
                  data-article-id={articleInfo.id}
                  data-replyto="我来说两句"
                  data-comment-id="0"
                  data-parent-comment-id="0"
                >
                  来说说我的看法...
                </span>
              }
            </div>
          )}
          {/*  展示文中商品弹窗  */}
          <div
            className="goodsModal"
            style={convertLineStyleData('display:' + (showModal ? 'block' : 'none'))}
            onClick={this.closeModal}
          >
            <div className="goodsWrap-bg" onClick={this.showModal}>
              <div className="goodsHidden" onClick={this.closeModal}>
                <span className="ico-moon icon-downarrow"></span>
              </div>
              <ScrollView scrollY className="goodsWrap">
                <div className="goodsWrap-title">
                  {articleInfo.form_data && articleInfo.form_data.show_recommend && ('文中商品(' +
                    articleInfo.form_data.show_recommend.recommend_goods
                      .length +
                    ')')}
                </div>
                {articleInfo.form_data && articleInfo.form_data.show_recommend && articleInfo.form_data.show_recommend.recommend_goods.map(
                  (item, index) => {
                    return (
                      <div className="goods-item" key={index}>
                        <div className="goods-item-img">
                          <img src={item.cover} />
                        </div>
                        <div className="introduce-text">
                          <div>
                            <span className="goods-item-detail">
                              {item.title}
                            </span>
                          </div>
                          <div>
                            <span className="goods-item-price">
                              {'¥' + item.price}
                            </span>
                            <span
                              className="goods-item-toShop"
                              data-id={item.id}
                              data-app-id={item.app_id}
                              onClick={this.turnToGoodsDetail}
                            >
                              去购买
                            </span>
                          </div>
                        </div>
                      </div>
                    )
                  }
                )}
              </ScrollView>
            </div>
          </div>
        </div>
        {showActionSheet && (
          <div className="actionSheet-wrap" onTouchMove={this.privateStopNoop}>
            <div className="actionSheet-buttons">
              <div className="phoneNum-btn">{phoneNumCall}</div>
              <div className="call-btn" onClick={this.makePhoneCall}>
                呼叫
              </div>
              <div className="cancel-btn" onClick={this.closeActionSheet}>
                取消
              </div>
            </div>
          </div>
        )}
        <div className="goback-top" onClick={this.tapBackPageTop}>
          <span className="ico-moon icon-news-totop"></span>
        </div>
        {/*  ++++++++2019-3-28-11:11  */}
        {/*  新版评论框  */}
        {showReplyBox && (
          <div
            className="communityDetail-comment-mask"
            onClick={this.cancelReply}
          ></div>
        )}
        {showReplyBox && (
          <div
            className="communityDetail-comment-box"
            id="comment-box"
          >
            <div className="communityDetail-comment-top">
              <textarea
                className="communityDetail-comment-input"
                id="communityDetail-comment-input"
                placeholder={replyPlaceholder}
                maxLength="-1"
                value={replyParam.text}
                onInput={this.replyInput}
                onChange={() => {}}
              ></textarea>
              {/*  放置图片、位置  */}
              {(replyParam.comment_img_url || replyParam.address) && (
                <div className="communityDetail-comment-others">
                  {replyParam.comment_img_url && (
                    <div
                      className="communityDetail-comment-others-image"
                      style={convertLineStyleData(
                        'margin-bottom: ' +
                        (replyParam.address ? '36' : '0') +
                        'rpx;'
                      )}
                    >
                      <img
                        src={replyParam.comment_img_url}
                        mode="aspectFill"
                        onClick={this.replyImagePreview}
                        lazyload="true"
                      />
                      <div
                        className="image-close-icon-box"
                        onClick={this.replyImageDelete}
                      >
                        <span className="image-close-icon ico-moon icon-closes"></span>
                      </div>
                    </div>
                  )}
                  {replyParam.address && (
                    <div
                      className="communityDetail-comment-others-location"
                      onClick={this.replyLocationDelete}
                    >
                      <span>{replyParam.address}</span>
                      <span className="location-close-icon ico-moon icon-closes"></span>
                    </div>
                  )}
                </div>
              )}
            </div>
            {/*  上传图片按钮、选择位置按钮、发布按钮  */}
            <div className="communityDetail-comment-bottom">
              <div className="communityDetail-comment-bottom-left">
                {/* <span
                  className="communityDetail-comment-bottom-icon ico-moon icon-news-input-image"
                  onClick={this.replyImageChoose}
                ></span> */}
                <span
                  className="communityDetail-comment-bottom-icon ico-moon icon-community-location"
                  onClick={this.replyLocationChoose}
                ></span>
              </div>
              <div className="communityDetail-comment-bottom-right">
                <div
                  className="communityDetail-comment-bottom-right-cancel"
                  onClick={this.cancelReply}
                >
                  <span>取消</span>
                </div>
                <div
                  className="communityDetail-comment-bottom-right-send"
                  onClick={this.submitReply}
                >
                  <span>发布</span>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/official-page/community-detail/CommunityDetail.jsx